import React, { useState, useContext, useEffect }from 'react';
import { useIonRouter, IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel, IonPage, IonList, IonIcon, IonRefresher, IonRefresherContent, IonModal, IonText  } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { helpCircleOutline, menuOutline } from 'ionicons/icons';

//import { SelectDateRange } from '../components/SelectDateRange';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
//import { App_Footer } from '../components/App_Footer';

import '../../../css/layout.css';


import { useHistory} from "react-router-dom";

 export function Modal_UpdateCompanyInfo (props) {

    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [acctID, setAccountID ] = useState(authMerchant_objects.acctID);
    let [employeeID, setEmployeeID ] = useState(authMerchant_objects.employeeID);
    let [schema, setSchema ] = useState(authMerchant_objects.schema);
    let [access, setAccessRights ] = useState(authMerchant_objects.accessRights);
    let [sessionID, setSessionID ] = useState(authMerchant_objects.sessionID);
    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);

    let [viewMerchantList_info, setViewMerchantList_info] = useState([]);
    let [companyID, setCompanyID] = useState('');
    let [companySchema, setCompanySchema] = useState('');
    let [companyName, setCompanyName] = useState('');
    let [companyAddressNumber, setCompanyAddressNumber] = useState('');
    let [companyStreetName, setCompanyStreetName] = useState('');
    let [companyCity, setCompanyCity] = useState('');
    let [companyCityDistrict, setCompanyCityDistrict] = useState('');
    let [companyPhoneNumber, setCompanyPhoneNumber] = useState('');
    let [companyEmail, setCompanyEmail] = useState('');
    let [customerRating, setCustomerRating] = useState('0.00000');
    let [companyLatitude, setCompanyLatitude] = useState('');
    let [companyLongitude, setCompanyLongitude] = useState('');
    let [companyInfoModal, setCompanyInfoModal] = useState(props.openModal);
    let [mtnCompanyPhoneNumber, setMtnCompanyPhoneNumber] = useState('');

    let [saveDisabled, setSaveDisabled] = useState(true);

    const isInvalid = (v) => ['', 'null', 'NULL', 'undefined'].includes(v);

    let history = useHistory();
    let router = useIonRouter();



    useEffect(() => {
        

        setViewMerchantList_info([]);


            const requestOptions = {
                method:'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    },
                body: JSON.stringify({
                    Tracker: "00_retrieve_company_info",
                    user: acctID,
                    sessionID: sessionID,

                })            }
    
            //alert('In ghanaverifiedApp - HotelList UseEffect');

            fetch(baseURL+'ghanaverified/', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');
                for(let rowNum = 0; rowNum < rows.length - 1; ++rowNum)
                {
                    let cols_spit = rows[rowNum].split('#');
                    let cols = cols_spit[0].split('|');
                    let cols_1 = cols_spit[1].split('|');
 

                    setViewMerchantList_info((prevViewMerchantList_proServices) => {
                        return prevViewMerchantList_proServices.concat({
                            companyAcctID: cols[0],
                            companyName: cols[1],
                            companyAddressNumber: cols[2],
                            streetName: cols[3],
                            city: cols[4],
                            cityDistrict: cols[5],
                            companyPhoneNumber: cols[6],
                            companyEmail: cols[7],
                            companyImage: cols[8],
                            companySchema: cols[9],
                            customerRating: cols[10],
                            latitude: cols[11],
                            longitude: cols[12],
                            mtnCompanyPhoneNumber: cols[13],
                            merchantID: cols_1[0], 
                            merchantName: cols_1[1],
                            merchantMomoNumber: cols_1[2],
                            merchantUpload_ghanaID: cols_1[3],
                            merchantUpload_businessRegistrationID: cols_1[4],
                            merchantAddress: cols_1[5],
                            latitude: cols_1[6],
                            longitude: cols_1[7],
                            merchantUpload_companyMainImage: cols_1[8],
                            companyShowcase: cols_1[9],
                            date_logged: cols_1[10],
                            onboardingStatus: cols_1[11],
                        })

                    });

                        setCompanyID(cols[0]);
                        setCompanySchema(cols[9]);
                        setCompanyName(cols[1]);
                        setCompanyAddressNumber(cols[2]);
                        setCompanyStreetName(cols[3]);
                        setCompanyCity(cols[4]);
                        setCompanyCityDistrict(cols[5]);
                        setCompanyEmail(cols[7]);
                        setCompanyPhoneNumber(cols[6]);
                        setCustomerRating(cols[10]);
                        setCompanyLatitude(cols[11]);
                        setCompanyLongitude(cols[12]);
                        setMtnCompanyPhoneNumber(cols[13]);
                }

                //props.confirmComplete();
                setSaveDisabled(false);
            })
    }, []);

function submit_updateCompanyProfile()
{

    let formData = new FormData();
    formData.append('Tracker', '00_updateCompanyInformation');
    formData.append('user', acctID);
    formData.append('merchantSchema', schema);
    formData.append('xCompanyAcctID', companyID);
    formData.append('xCompanyName', companyName)
    formData.append('xCompanyAddressNumber', companyAddressNumber);
    formData.append('xCompanyStreetName', companyStreetName);
    formData.append('xCompanyCity', companyCity);
    formData.append('xCompanyCityDistrict', companyCityDistrict);
    formData.append('xCompanyPhoneNumber', companyPhoneNumber);
    formData.append('xCompanyEmail', companyEmail);
    //formData.append('xImageFile', companyImage);
    formData.append('xCompanySchema', companySchema);
    formData.append('xCompanyRating', customerRating);
    formData.append('xCompanyLongitude', companyLongitude);
    formData.append('xCompanyLatitude', companyLatitude);
    formData.append('xMtnCompanyPhoneNumber', mtnCompanyPhoneNumber);
    //formData.append('xImageFile', selectedFile);
    formData.append('sessionID', sessionID);

    const requestOptions = {
        enctype: 'multipart/form-data',
        method:'POST',
        credentials: 'include',
        files: formData,
        body: formData,
        contentType: false,
        processData: false,
    }


    fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        alert(res);

        props.closeModal();
    })
}



    return (
            <React.Fragment>
                        <IonModal isOpen={ props.openModal }>
                            <IonHeader>
                                <IonToolbar>
                                <IonTitle>{"COMPANY INFO"}</IonTitle>
                                <IonButtons slot="end">
                                    <IonButton fill="outline" color="success" onClick={() => props.closeModal()}>Close</IonButton>
                                </IonButtons>
                                </IonToolbar>
                            </IonHeader>
                            <IonContent className='grid_content'>
                            <IonGrid>
                                   <IonRow>
                                        <IonCol size='12'>
                                            <h5 style={{color: 'red'}}>PLEASE UPDATE CRITICAL COMPANY INFO</h5>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <h5 >Company Name: </h5>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className={isInvalid(companyName) ? 'professional-input input-invalid' : 'professional-input input-valid'} type='text' value={companyName} placeholder='Enter Company Name' autocomplete='off' onIonChange={(e) => setCompanyName(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <h5 >Address #: </h5>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className={'professional-input input-valid'} type='text' value={companyAddressNumber} placeholder='Enter Address Number' autocomplete='off' onIonChange={(e) => setCompanyAddressNumber(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <h5 >Street Name: </h5>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className={isInvalid(companyStreetName) ? 'professional-input input-invalid' : 'professional-input input-valid'} type='text' value={companyStreetName} placeholder='Enter Street Name' autocomplete='off' onIonChange={(e) => setCompanyStreetName(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <h5 >City: </h5>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className={isInvalid(companyCity) ? 'professional-input input-invalid' : 'professional-input input-valid'} type='text' value={companyCity} placeholder='Enter City' autocomplete='off' onIonChange={(e) => setCompanyCity(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <h5 >City District: </h5>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className={'professional-input input-valid'} type='text' value={companyCityDistrict} placeholder='Enter District' autocomplete='off' onIonChange={(e) => setCompanyCityDistrict(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                   <IonRow>
                                        <IonCol size='6'>
                                            <h5 >Contact Number: </h5>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className={isInvalid(companyPhoneNumber) ? 'professional-input input-invalid' : 'professional-input input-valid'} type='text' value={companyPhoneNumber} placeholder='Enter MTGN Phone' autocomplete='off' onIonChange={(e) => setCompanyPhoneNumber(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <h5 >MTN Momo Number: </h5>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className={isInvalid(mtnCompanyPhoneNumber) ? 'professional-input input-invalid' : 'professional-input input-valid'} type='text' value={mtnCompanyPhoneNumber} placeholder='Enter MTGN Phone' autocomplete='off' onIonChange={(e) => setMtnCompanyPhoneNumber(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                            </IonGrid>
                            </IonContent>
                            <IonFooter className='grid_footer'>
                                <IonGrid>
                                    <IonRow>
                                        <IonCol size='12'>
                                            <IonButton disabled={saveDisabled} onClick={() => submit_updateCompanyProfile()}>Save</IonButton>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                            </IonFooter>
                        </IonModal>
            </React.Fragment>

    );
};



export default Modal_UpdateCompanyInfo;